import React from 'react';
import attachIcon from '../../../../../assests/icons/attach.png';
import './Vc008UploadPreviewRow.css';

export interface Vc008UploadPreviewRowProps {
  fileName: string;
  previewUrl: string | null;
  previewLabel: string;
  openLabel: string;
}

const Vc008UploadPreviewRow: React.FC<Vc008UploadPreviewRowProps> = ({
  fileName,
  previewUrl,
  previewLabel,
  openLabel,
}) => {
  const lower = fileName.toLowerCase();
  const isImage =
    lower.endsWith('.jpg') ||
    lower.endsWith('.jpeg') ||
    lower.endsWith('.png') ||
    lower.endsWith('.gif') ||
    lower.endsWith('.webp');

  return (
    <div className="cu-vc008-preview">
      <p className="cu-vc008-preview__label">{previewLabel}</p>
      <div className="cu-vc008-preview__card">
        <img src={attachIcon} alt="" className="cu-vc008-preview__attach" aria-hidden />
        <div className="cu-vc008-preview__meta">
          <span className="cu-vc008-preview__name">{fileName}</span>
          {previewUrl && (
            <a
              className="cu-vc008-preview__link"
              href={previewUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {openLabel}
            </a>
          )}
        </div>
      </div>
      {previewUrl && isImage && (
        <a href={previewUrl} target="_blank" rel="noopener noreferrer" className="cu-vc008-preview__thumb-wrap">
          <img src={previewUrl} alt={fileName} className="cu-vc008-preview__thumb" />
        </a>
      )}
    </div>
  );
};

export default Vc008UploadPreviewRow;
